import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import { httpClient } from './http-client';

import type {
  CreateUserDocumentDto,
  UpdateUserDocumentDto,
  UserDocumentDto,
  UsersControllerFindAllUserDocumentsData,
  UsersControllerRemoveUserDocumentResponse,
} from '@carvia/ros-client-types';

class UserDocumentsService {
  httpClient = httpClient;
  endpoint = '/users/';
  subEndpoint = '/documents';

  async getAllPaginated(userId: string, params: UsersControllerFindAllUserDocumentsData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<UserDocumentDto>>(
      `${this.endpoint}${userId}${this.subEndpoint}`,
      {
        params,
      },
    );
    return res.data;
  }
  async getOne(userId: string, documentId: string) {
    const res = await this.httpClient.get<UserDocumentDto>(
      `${this.endpoint}${userId}${this.subEndpoint}/${documentId}`,
    );
    return res.data;
  }
  async update(userId: string, documentId: string, data: UpdateUserDocumentDto) {
    const res = await this.httpClient.patch<UserDocumentDto>(
      `${this.endpoint}${userId}${this.subEndpoint}/${documentId}`,
      data,
    );
    return res.data;
  }
  async create(userId: string, data: CreateUserDocumentDto) {
    const res = await this.httpClient.post<UserDocumentDto>(
      `${this.endpoint}${userId}${this.subEndpoint}`,
      data,
    );
    return res.data;
  }
  async remove(userId: string, documentId: string) {
    const res = await this.httpClient.delete<UsersControllerRemoveUserDocumentResponse>(
      `${this.endpoint}${userId}${this.subEndpoint}/${documentId}`,
    );
    return res.data;
  }
}

export const userDocumentsService = new UserDocumentsService();
